module.exports = __webpack_public_path__ + "img/education.b53cf599.svg";